import { render, staticRenderFns } from "./OverseasPersonnelPortVisa.vue?vue&type=template&id=0efcd741&scoped=true&"
import script from "./OverseasPersonnelPortVisa.vue?vue&type=script&lang=js&"
export * from "./OverseasPersonnelPortVisa.vue?vue&type=script&lang=js&"
import style0 from "./OverseasPersonnelPortVisa.vue?vue&type=style&index=0&id=0efcd741&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcd741",
  null
  
)

export default component.exports